import type {Theme} from '../theme';
import {createBaseThemeVariation} from './base';

// Teal rather than a partner colour: the staging test whitelabel needs to be
// distinguishable from Famly at a glance, without impersonating a real customer.
export const WhitelabelTestTheme: Theme = createBaseThemeVariation({
    name: 'whitelabeltest',
    brandColor: 'hsla(175, 77%, 26%, 1)',
    primaryColors: {
        p50: 'hsla(175, 77%, 97%, 1)',
        p75: 'hsla(175, 77%, 95%, 1)',
        p100: 'hsla(175, 77%, 92%, 1)',
        p200: 'hsla(175, 77%, 75%, 1)',
        p300: 'hsla(175, 77%, 65%, 1)',
        p400: 'hsla(175, 77%, 26%, 1)',
        p500: 'hsla(175, 77%, 16%, 1)',
    },
});
